import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DTSearchInput from '../DTSearchInput/DTSearchInput';
import { LoadingStateWrapper } from '../../../common/LoadingStateWrapper/LoadingStateWrapper';
import { LoadingStateContextConsumer } from '../../../common/LoadingStateWrapper/LoadingStateContext';
import { Loader } from '../../../common/Loader/Loader';
import SearchPageNextButton from '../../NodeGroups/DTOrderSearch/Common/SearchPageNextButton/SearchPageNextButton';
import { returnToPreviousMacroWizardPath } from '../../../../actions/searchActions';
import { getCurrentDecisionNodeContent } from '../../../../extractFromState';
import { getSearchPageLoadingState } from '../../../../selectors/tools';
import {
  Container,
  HeaderContainer,
  ResultsSection,
  SearchAndResults,
  SearchInputContainer,
  SearchContent,
  SearchOrdersBox,
  SearchResultsContainer,
  SpaceHolder,
  SubTitle,
  Title,
} from './DTSearchView.styles';
import { BackButton } from '../../../common/buttonsComponents';
import { ActionsButtonsWrapper } from '../../DecisionTree.styles';

const DTSearchView = (props) => {
  const {
    isNextButtonActive,
    onNextButtonClick,
    handleSearchSubmit,
    searchType,
    searchValue,
    defaultValue,
    dataToDisplay,
    loadingLabel,
    searchPageSelectComponent,
    searchResultsComponent,
    noDataMessageComponent,
    introMessageComponent,
    placeholder = 'Search keywords',
  } = props;

  const content = useSelector(getCurrentDecisionNodeContent);
  const isLoading = useSelector(getSearchPageLoadingState);

  const dispatch = useDispatch();
  const handleBackButtonClick = () => dispatch(returnToPreviousMacroWizardPath());

  return (
    <Container>
      <HeaderContainer id="HeaderContainer">
        {content?.title && <Title>{content.title}</Title>}
        {content?.subText && <SubTitle>{content.subText}</SubTitle>}
        <SearchOrdersBox>
          {searchPageSelectComponent && <SearchInputContainer>{searchPageSelectComponent}</SearchInputContainer>}
          <SearchInputContainer>
            <DTSearchInput
              placeholder={placeholder}
              messageImg={false}
              searchType={searchType}
              searchValue={searchValue}
              defaultValue={defaultValue}
              onSearchSubmit={handleSearchSubmit}
            />
          </SearchInputContainer>
          <SpaceHolder />
        </SearchOrdersBox>
      </HeaderContainer>
      <SearchResultsContainer>
        <LoadingStateWrapper
          data={dataToDisplay}
          isPending={isLoading}
          loadingLabel={loadingLabel}
          noDataMessage={noDataMessageComponent}
          introMessage={introMessageComponent}
        >
          <LoadingStateContextConsumer>
            {() => {
              return (
                <Loader visible={isLoading}>
                  <SearchContent id="SearchContent">
                    <SearchAndResults id="SearchAndResults">
                      <ResultsSection id="ResultsSection">{searchResultsComponent}</ResultsSection>
                    </SearchAndResults>
                  </SearchContent>
                </Loader>
              );
            }}
          </LoadingStateContextConsumer>
        </LoadingStateWrapper>
      </SearchResultsContainer>

      <ActionsButtonsWrapper key={'navigation'}>
        <SearchPageNextButton
          active={isNextButtonActive && !isLoading}
          disabled={!isNextButtonActive || isLoading}
          type="submit"
          onClick={onNextButtonClick}
        >
          NEXT
        </SearchPageNextButton>
        <BackButton onClick={handleBackButtonClick}>BACK</BackButton>
      </ActionsButtonsWrapper>
    </Container>
  );
};

DTSearchView.propTypes = {
  isNextButtonActive: PropTypes.bool.isRequired,
  onNextButtonClick: PropTypes.func.isRequired,
  handleSearchSubmit: PropTypes.func.isRequired,
  searchType: PropTypes.string.isRequired,
  searchValue: PropTypes.string,
  defaultValue: PropTypes.string,
  loadingLabel: PropTypes.string,
  dataToDisplay: PropTypes.array,
  searchPageSelectComponent: PropTypes.element,
  searchResultsComponent: PropTypes.element.isRequired,
  noDataMessageComponent: PropTypes.element.isRequired,
  introMessageComponent: PropTypes.element,
  placeholder: PropTypes.string,
};

export default DTSearchView;
